<template>
  <div>
    <div class="m-b-20">
      <router-link class="btn-link-large add-btn" to="add">
        <i class="el-icon-plus"></i>&nbsp;&nbsp;添加参数
      </router-link>
  </div>
    <el-table
      :data="tableData"
      stripe>
      <el-table-column
        prop="name"
        label="参数名"
        width="180">
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注说明"
        width="180">
      </el-table-column>
      <el-table-column
        prop="table_name"
        label="数据表">
      </el-table-column>
      <el-table-column
        prop="field_name"
        label="字段">
      </el-table-column>
      <el-table-column
        prop="is_serialize"
        label="类型">
      </el-table-column>
      <el-table-column width="100" label="操作">
        <template scope="scope">
          <div>
					  <router-link :to="{ name: 'parameterEdit', params: { id: scope.row.id }}" class="btn-link edit-btn">编辑</router-link>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pos-rel p-t-20">
      <div class="block pages">
        <el-pagination
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :page-size="tableSetting.limit"
          :current-page="tableSetting.page"
          :total="dataCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import http from '../../assets/js/http'
  export default {
    data() {
      return {
        loading: false,
        tableData: [],
        tableSetting: {
          keywords: '',
          limit: 15,
          page: 1,
          status: 1
        },
        dataCount: null
      }
    },
    methods: {
      // 获取当前选中页数
      handleCurrentChange(page) {
        this.tableSetting.page = page || 1
        this.getTableData()
      },
      // 异步变同步
      async getTableData() {
        this.loading = true
        let self = this
        let postData = self.tableSetting
        let paramData = {
          params: {
            limit: postData.limit,
            page: postData.page,
            status: postData.status,
            keywords: postData.keywords
          }
        }
        // 访问列表数据接口
        let res = await this.apiGet(`pd/config`, paramData)
        let data = await this.promiseHandler({}, res)
        // 获取数据
        this.tableData = data.list
        this.dataCount = data.dataCount
      },
      init() {
        this.getTableData()
      }
    },
    created() {
      // 获取参数管理列表数据
      this.init()
    },
    mixins: [http]
  }
</script>



// WEBPACK FOOTER //
// list.vue?1641fe7e